(function () {
  if (window.__fxScriptsInit) return;
  window.__fxScriptsInit = true;

function fxInitReveals() {
  var els = document.querySelectorAll('.fx-reveal:not(.fx-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fx-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fx-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function fxInitCountUp() {
  var els = document.querySelectorAll('[data-fx-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.dataset.fxCount) || 0;
        var suffix = el.dataset.fxSuffix || '';
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function fxInitMarquee() {
  document.querySelectorAll('[data-fx-marquee]').forEach(function (track) {
    if (track.dataset.fxMarqueeReady) return;
    track.dataset.fxMarqueeReady = '1';
    track.innerHTML += track.innerHTML;
  });
}

function fxInitGaleria() {
  document.querySelectorAll('[data-fx-thumb]').forEach(function (thumb) {
    if (thumb.dataset.fxInit) return;
    thumb.dataset.fxInit = '1';
    thumb.addEventListener('click', function () {
      var wrap = thumb.closest('.fx-producto-galeria');
      if (!wrap) return;
      var mainImg = wrap.querySelector('.fx-galeria-principal img');
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      mainImg.alt = thumb.dataset.alt || '';
      wrap.querySelectorAll('[data-fx-thumb]').forEach(function (t) { t.classList.remove('fx-thumb-activo'); });
      thumb.classList.add('fx-thumb-activo');
    });
  });
}

function fxInitCantidad() {
  document.querySelectorAll('.fx-cantidad').forEach(function (wrap) {
    if (wrap.dataset.fxInit) return;
    wrap.dataset.fxInit = '1';
    var input = wrap.querySelector('.fx-cantidad-input');
    if (!input) return;
    wrap.querySelectorAll('[data-fx-cantidad]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val = btn.dataset.fxCantidad === 'mas' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });
}

function fxInitVariantes() {
  document.querySelectorAll('.fx-producto-form').forEach(function (form) {
    if (form.dataset.fxInit) return;
    form.dataset.fxInit = '1';
    var section = form.closest('.fx-producto');
    if (!section) return;
    var jsonEl = form.querySelector('[data-fx-variantes-json]');
    var opcionesWrap = form.querySelector('[data-fx-opciones]');
    if (!jsonEl || !opcionesWrap) return;

    var variantes;
    try {
      variantes = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var selects = Array.prototype.slice.call(opcionesWrap.querySelectorAll('.fx-opcion-select'));
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = section.querySelector('.fx-precio-actual');
    var precioComparadoEl = section.querySelector('.fx-precio-tachado');
    var boton = section.querySelector('.fx-boton-comprar');
    var botonTexto = boton ? boton.querySelector('[data-fx-boton-texto]') : null;
    var textoDisponible = botonTexto ? botonTexto.textContent.trim() : '';

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    }

    function actualizar() {
      var seleccion = selects.map(function (s) { return s.value; });
      var match = variantes.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return opts.every(function (o, i) { return o === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioEl) precioEl.textContent = moneda(match.price);
      if (precioComparadoEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioComparadoEl.textContent = moneda(match.compare_at_price);
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !match.available;
        if (botonTexto) botonTexto.textContent = match.available ? textoDisponible : (boton.dataset.fxAgotado || 'Agotado');
      }

      var variantImgSrc = match.featured_image && (match.featured_image.src || match.featured_image.url);
      if (variantImgSrc) {
        var mainImg = section.querySelector('.fx-galeria-principal img');
        if (mainImg) {
          mainImg.src = variantImgSrc;
          mainImg.alt = match.public_title || match.title || mainImg.alt;
        }
        var fileName = variantImgSrc.split('?')[0].split('/').pop();
        var thumbs = section.querySelectorAll('[data-fx-thumb]');
        thumbs.forEach(function (t) {
          var tFile = (t.dataset.full || '').split('?')[0].split('/').pop();
          var isMatch = fileName && tFile && (tFile === fileName || tFile.indexOf(fileName) !== -1 || fileName.indexOf(tFile) !== -1);
          t.classList.toggle('fx-thumb-activo', !!isMatch);
        });
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function fxInitSpotlight() {
  document.querySelectorAll('[data-fx-spotlight]').forEach(function (el) {
    if (el.dataset.fxInit) return;
    el.dataset.fxInit = '1';
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--fx-mx', x + '%');
      el.style.setProperty('--fx-my', y + '%');
    });
  });
}

function fxInitHotspots() {
  document.querySelectorAll('[data-fx-hotspot]').forEach(function (dot) {
    if (dot.dataset.fxInit) return;
    dot.dataset.fxInit = '1';
    dot.addEventListener('click', function () {
      var wrap = dot.closest('[data-fx-hotspots-wrap]');
      if (!wrap) return;
      var isOpen = dot.classList.contains('fx-hotspot-activo');
      wrap.querySelectorAll('[data-fx-hotspot]').forEach(function (d) {
        d.classList.remove('fx-hotspot-activo');
        d.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        dot.classList.add('fx-hotspot-activo');
        dot.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function fxInitAntesDespues() {
  document.querySelectorAll('[data-fx-antes-despues]').forEach(function (wrap) {
    if (wrap.dataset.fxInit) return;
    wrap.dataset.fxInit = '1';

    var antes = wrap.querySelector('[data-fx-ad-antes]');
    var linea = wrap.querySelector('[data-fx-ad-linea]');
    var handle = wrap.querySelector('[data-fx-ad-handle]');
    if (!antes || !handle) return;

    var dragging = false;

    function setPercent(pct) {
      pct = Math.max(0, Math.min(100, pct));
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      if (linea) linea.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function percentFromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(percentFromClientX(clientX));
    }
    function onUp() {
      dragging = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
    }
    function onDown(e) {
      dragging = true;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(percentFromClientX(clientX));
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchmove', onMove, { passive: true });
      document.addEventListener('touchend', onUp);
      e.preventDefault();
    }

    handle.addEventListener('mousedown', onDown);
    handle.addEventListener('touchstart', onDown, { passive: false });
    wrap.addEventListener('mousedown', function (e) {
      if (e.target === handle) return;
      onDown(e);
    });
    wrap.addEventListener('touchstart', function (e) {
      if (e.target === handle) return;
      onDown(e);
    }, { passive: false });

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { setPercent(current - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPercent(current + 5); e.preventDefault(); }
    });
  });
}

function fxInitAll() {
  fxInitReveals();
  fxInitCountUp();
  fxInitMarquee();
  fxInitGaleria();
  fxInitCantidad();
  fxInitVariantes();
  fxInitSpotlight();
  fxInitHotspots();
  fxInitAntesDespues();
}

document.addEventListener('DOMContentLoaded', fxInitAll);
document.addEventListener('shopify:section:load', fxInitAll);

})();
